import React from "react";
import { Button } from "@/shared/ui/Button";

const ErrorPage: React.FC = () => (
  <div className="min-h-screen flex items-center justify-center bg-gray-50">
    <div className="max-w-md w-full space-y-8 p-8 bg-white rounded-lg shadow-lg">
      <div className="flex flex-col items-center">
        <div className="w-16 h-16 mb-4">
          <i className="far fa-times-octagon text-4xl text-red-500" />
        </div>
        <h1 className="text-2xl font-bold text-gray-900 text-center">
          Oops, something went wrong.
        </h1>
        <h1 className="text-xl font-semibold text-gray-700 text-center mt-2">
          Refresh page to try again.
        </h1>
        <p className="mt-4 text-center text-gray-600">
          If the problem persists, please contact us at{" "}
          <a
            href="mailto:support@assessio.ai"
            className="text-blue-600 hover:text-blue-800 underline"
          >
            support@assessio.ai
          </a>{" "}
          or use chat.
        </p>
        <div className="mt-8">
          <Button
            variant="default"
            size="lg"
            onClick={() => {
              window.location.replace("/dashboard");
            }}
          >
            Back to safety
          </Button>
        </div>
      </div>
    </div>
  </div>
);

export default ErrorPage;
